import { Injectable } from "@nestjs/common"
import { InjectRepository } from "@nestjs/typeorm"
import {  getManager, Repository } from "typeorm"

import {  AssetCheckListEntity } from "./asset-checklist.entity"
import { AssetCheckListDto } from "./asset-checklist.dto"
import { AssetCheckListReq } from "@gtpl/shared-models/masters"
import { CommonResponse } from "@gtpl/shared-models/production-management"
import { ErrorResponse } from "@gtpl/shared-models/common-models"
import { AssetCheckListAdapter } from "./asset-checklist-adapter"

@Injectable()
export class AssetCheckListService {
    constructor(
        @InjectRepository(AssetCheckListEntity)
       
        private repo: Repository<AssetCheckListEntity>,
        private checklistAdapter: AssetCheckListAdapter,
        // private readonly dataSource: DataSource,

    ) { }

    async createAssetCheckList(req?: AssetCheckListReq, isUpdate?: boolean): Promise<CommonResponse> {
        console.log(req, "/////////////////////");
    
        try {
           
            const savedRecords: AssetCheckListEntity[] = [];
    
            
            if (!req.assetCategory || !Array.isArray(req.assetCategory) || req.assetCategory.length === 0) {
                return new CommonResponse(false, 0, 'No asset categories provided');
            }
    
            for (const assetCategoryId of req.assetCategory) {
                const entity = new AssetCheckListEntity();
    
               
                const existingRec = await this.repo.findOne({ where: { checkListid: req.checkListid, assetCategoryId } });
    
                if (existingRec) {
                   
                    existingRec.checkListName = Array.isArray(req.checkListName) ? req.checkListName.join(",") : req.checkListName;
                    existingRec.updatedUser = req.createdUser;
    
                    
                    const updatedRecord = await this.repo.save(existingRec);
                    savedRecords.push(updatedRecord);
                } else {
                    
                    entity.checkListid = req.checkListid; 
                    entity.assetCategoryId = assetCategoryId;
                    entity.checkListName = Array.isArray(req.checkListName) ? req.checkListName.join(",") : req.checkListName;
                    entity.model = req.model;
                    entity.subName = req.subName;
                    entity.createdUser = req.createdUser;
    
                    // Save the new entity
                    const newRecord = await this.repo.save(entity);
                    savedRecords.push(newRecord);
                }
            }
    
            return new CommonResponse(true, 1, 'Records processed successfully', savedRecords);
        } catch (err) {
            throw err;
        }
    }
    

    

    

   async getAllAssetCheckList():Promise<CommonResponse>{  
    const query=`select ac.checklist_id as checkListid,ac.checklist_name as checkListName,ac.model as model,ac.sub_name as subName, ac.is_active as isActive,acm.check_list as checkListId,it.item_name as itemName,it.item_id as itemId,ac.asset_Category_id as assetCategory
    FROM asset_checklist ac 
  
   LEFT JOIN items it ON it.item_id = ac.asset_Category_Id
   LEFT JOIN checklistmodel acm ON acm.check_list_id = ac.checklist_name`
   const result = await this.repo.query(query)
   console.log(result,"result..........................")
   if (result.length > 0) {
    return new CommonResponse(true, 1, 'data retrived Sucessfully', result)
}
    return new CommonResponse(true, 1, 'data retrived Sucessfully', [])   }



    async getActiveAllAssetCheckList(): Promise<CommonResponse> {
        const data = await this.repo.find({
            where: {
                isActive: true
            },
            order:{"checkListName":"ASC"}
        })

        if (data.length > 0) {
            return new CommonResponse(true, 1, 'data retrived Sucessfully', data)
        }
        return new CommonResponse(true, 1, 'data retrived Sucessfully', [])
    }


    async updateAssetCheckList(req: AssetCheckListReq): Promise<CommonResponse> {

        try {
            let Product;
            Product = await this.repo.update(
                { checkListid: req.checkListid },
                {
                    checkListName: req.checkListName[''],
                }
            )
            if (Product.affected > 0) {
                return new CommonResponse(true, 11, 'updated successfully', Product);
            }
            else {
                return new CommonResponse(false, 11, 'uploaded failed', []);
            }
        }
        catch (error) {
            console.log(error);
        }
    }


   
    async activateOrDeactivateAssetCheckList(req: AssetCheckListReq): Promise<CommonResponse> {
        try {
            console.log(req.isActive, 'service-----------');
            console.log(req.checkListid, 'checkListid-----------');  // Log the checkListid
    
            const Exists = await this.repo.findOne({ where: { checkListid: req.checkListid } });
            console.log(Exists, 'Exists-----------');  // Log the found record
    
            if (Exists) {
                if (!Exists) {
                    throw new ErrorResponse(10113, 'Someone updated the current VehicleCategory information. Refresh and try again');
                } else {
                    const update = await this.repo.update(
                        { checkListid: req.checkListid },
                        { isActive: req.isActive, updatedUser: req.updatedUser }
                    );
                    if (Exists.isActive) {
                        if (update.affected) {
                            const Response: CommonResponse = new CommonResponse(true, 10115, 'AssetChecklist is Deactivated successfully');
                            return Response;
                        } else {
                            throw new CommonResponse(false, 10111, 'AssetChecklist is already deactivated');
                        }
                    } else {
                        if (update.affected) {
                            const Response: CommonResponse = new CommonResponse(true, 10114, 'AssetChecklist is activated successfully');
                            return Response;
                        } else {
                            throw new CommonResponse(false, 10112, 'AssetChecklist is already activated');
                        }
                    }
                }
            } else {
                throw new CommonResponse(false, 99998, 'No Records Found');
            }
        } catch (err) {
            console.error('Error:', err);  // Log the error
            return err;
        }
    }
   
    

}